module.exports = __webpack_public_path__ + "static/media/exclusive-back-img.5c0adfe9.png";